import { oneSecond } from 'src/app/utils/time';

/**
 * Contains and manages feedback strings
 */
export class DataUpdateFeedback {
  private error = '';
  private success: 'success-updating-data' | '' = '';

  /**
   * Sets this as a successful update feedback
   */
  setSuccess() {
    this.error = '';
    this.success = 'success-updating-data';
    this.timedoutReset();
  }

  /**
   * Sets this as a fail feedback
   * @param {string} errorToken
   * @param {boolean} timeout
   */
  setError(errorToken?: string, timeout: boolean = true) {
    this.error = errorToken || 'error-updating-data';
    this.success = '';
    if (timeout) {
      this.timedoutReset();
    }
  }

  /**
   * Sets this as a fail feedback
   * @param {boolean} timeout
   */
  setExistingBusinessEmailError(timeout: boolean = true) {
    this.error = 'business-contact-email-already-used';
    this.success = '';
    if (timeout) {
      this.timedoutReset();
    }
  }

  /**
   * Resets this feedback after a while
   */
  timedoutReset() {
    setTimeout(() => this.reset(), oneSecond * 3);
  }

  /**
   * Resets this feedback
   */
  reset() {
    this.error = '';
    this.success = '';
  }

  /**
   * Retrieves this feedback
   */
  get feedback() {
    return this.error || this.success;
  }

  /**
   * If there is some feedback available
   * @return {boolean}
   */
  hasFeedback(): boolean {
    return Boolean(this.feedback);
  }

  /**
   * If this feedback is an error;
   */
  get isError() {
    return Boolean(this.error);
  }

  /**
   * If this feedback is a success;
   */
  get isSuccess() {
    return Boolean(this.success);
  }
}
